import { render, staticRenderFns } from "./carLot-infor.vue?vue&type=template&id=6133f886&scoped=true&"
import script from "./carLot-infor.vue?vue&type=script&lang=js&"
export * from "./carLot-infor.vue?vue&type=script&lang=js&"
import style0 from "./carLot-infor.vue?vue&type=style&index=0&id=6133f886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6133f886",
  null
  
)

export default component.exports